export enum RESPONDER_LIST_TYPE {
  ASSIGNEE = 'assignee',
  RESPONDER = 'responder',
}
